module.exports = __webpack_public_path__ + "static/monei_pay_3_es-bd70cff410d83cbf7e24035b578eb48b.png";